module.exports = __webpack_public_path__ + "img/process_small.6d23a73f.webp";